import React from "react";
import { toAbsoluteUrl } from "../../../_metronic";
import "../../../_metronic/_assets/sass/pages/error/error-1.scss";

export function ErrorPage1() {
  return (
    <>
      <div className="kt-grid kt-grid--ver kt-grid--root">
        <div
          className="kt-grid__item kt-grid__item--fluid kt-grid kt-error-v1"
          style={{
            backgroundImage: `url(${toAbsoluteUrl(
              "/media/error/bg1.jpg"
            )})`
          }}
        >
          <div className="kt-error-v1__container">
            <h1 className="kt-error-v1__number">404</h1>
            <p className="kt-error-v1__desc">OOPS! Something went wrong here <br /><button style={{ fontSize: "12px", marginTop: "25px", letterSpacing: "0.2rem", color: "#3d4852", padding: "12px 24px 12px 24px", fontWeight: 700, borderWidth: "2px", borderRadius: "0.5rem", borderColor: "#dae1e7", backgroundColor: "transparent", cursor: "pointer", fontFamily: "inherit" }} onClick={() => window.location.pathname = '/dashboard'}>Return Home</button></p>
          </div>
        </div>
      </div>
    </>
  );
}
